import { type FormEvent, type ReactElement, useState } from 'react';
import { Button, FormField } from '@/shared/ui';

interface BlockUserFormProps {
  /** 차단 대상 사용자의 이메일 — 폼 제목에 노출된다. */
  readonly email: string;
  readonly isPending: boolean;
  readonly onSubmit: (reason: string) => void;
  readonly onCancel: () => void;
}

/** 차단 사유를 입력받아 확정하는 폼 — 사유는 감사 로그에 남는다. */
export const BlockUserForm = ({
  email,
  isPending,
  onSubmit,
  onCancel,
}: BlockUserFormProps): ReactElement => {
  const [reason, setReason] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    if (reason.trim()) {
      onSubmit(reason.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-4 flex flex-col gap-3 rounded-lg border p-4">
      <p className="text-sm font-medium">{email} 차단</p>
      <FormField
        label="차단 사유"
        description="사유는 감사 로그에 남습니다."
        isRequired
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
      <div className="flex gap-2">
        <Button type="submit" variant="destructive" isLoading={isPending} disabled={!reason.trim()}>
          차단 확정
        </Button>
        <Button type="button" variant="outline" onClick={onCancel}>
          취소
        </Button>
      </div>
    </form>
  );
};
